module.exports = __webpack_public_path__ + "static/img/logo.e35f6e2b.svg";